import { Component, OnInit,Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'close-btn',
  template: `
  <div>
  <button class="btn text-0 bg-b100 p-0 m-0" (click)="onClick()"><i class="fa fa-times p-1" aria-hidden="true"></i></button>
</div>`,
  styleUrls: ['./close-btn.component.css']
})
export class CloseBtnComponent implements OnInit {

  @Output() clickEvent: any = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onClick(){
    this.clickEvent.emit(true);
  }
}
